import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../../../src/styles/colors';
import {
  ZeeFontBold,
  ZeeFontMedium,
  ZeeFontRegular,
  getInitialLoadIcons
} from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';
import { InitialLoadIconsSet } from '../../../utils/constants/IconsConstants';

export const MainContainer = styled.div<{
  isContactUs?: boolean;
  positionDownwards: boolean;
  isWindowingApplied?: boolean;
}>`
  ${flex('column', '', '')};
  ${({ isContactUs }) =>
    isContactUs ? `width: 100%; ${ZeeFontRegular(13, 15)}` : 'width: 212px'};
  position: absolute;
  ${(props) => (props.positionDownwards ? 'bottom: 110%;' : 'top: 110%;')}
  border-radius: 6px;
  z-index: 2;
  border: 1px solid ${colors.SearchCardBg};
  cursor: pointer;

  ${MQ.MediaMd} {
    ${({ isContactUs }) => (isContactUs ? 'width: 100%' : 'width: 239px')};
  }

  ${MQ.MediaLg} {
    ${({ isContactUs }) => (isContactUs ? 'width: 100%' : 'width: 257px')};
  }

  ${(props) =>
    !props.isWindowingApplied &&
    `
    max-height: 172px;
    overflow-y: scroll;
  `}
`;

export const SpanTag = styled.span<{
  isSelected: boolean;
  isContactUs: boolean;
}>`
  color: ${({ isContactUs }) =>
    isContactUs ? colors.PrimaryWhiteColorAlpha80 : colors.PrimaryWhiteColor};
  background: ${({ isSelected }) =>
    !isSelected ? colors.SearchCardBg : colors.LightPurpleColor};
  height: 48px;
  align-items: flex-start;
  padding: ${({ isContactUs }) => (isContactUs ? '16px' : '12px 16px')};
  cursor: pointer;
  ${MQ.MediaSm} {
    ${({ isContactUs }) =>
      isContactUs ? `padding: 16px; ${ZeeFontRegular(14, 16)}` : ''};
  }
  &:hover {
    background: ${colors.LightPurpleColor};
    border-bottom: 1px solid ${colors.SearchCardBg};
  }
`;

export const ChevronDown = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.RIGHT_CHEVRON)};
  transform: rotate(-90deg);
  transition: 0.2s;
`;

export const ChevronUp = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.RIGHT_CHEVRON)};
  transform: rotate(90deg);
  transition: 0.2s;
`;

export const widthStyling = (isContactUs = false) => css`
  ${isContactUs
    ? `
      width: 95%;
      ${MQ.MediaSm} {
        width: 97%;
      }
      ${MQ.MediaMd} {
        width: 100%;
      }
    `
    : ''}
`;

export const DropDownMainContainer = styled.div<{ isContactUs: boolean }>`
  position: relative;
  ${({ isContactUs }) =>
    !isContactUs ? 'margin: 12px 0 16px 0; max-width: 212px;' : ''};
  ${MQ.MediaMd} {
    ${({ isContactUs }) => (!isContactUs ? 'max-width: 257px' : '')};
  }
  ${MQ.MediaLg} {
    ${({ isContactUs }) =>
      !isContactUs ? 'height: 48px; max-width: 275px' : ''};
  }
`;

export const fieldContainer = (isContactUs = false) => css`
  background: transparent;
  ${isContactUs
    ? `border-bottom: 1px solid ${colors.Gray}`
    : `border: 1px solid ${colors.PrimaryWhiteColor}`};
  ${!isContactUs ? 'border-radius: 6px;' : ''}
  color: ${colors.PrimaryWhiteColor};
  padding: ${isContactUs ? '0 2px' : '0 12px'};
  height: 40px;
  ${!isContactUs ? 'max-width: 212px;' : ''}
  ${flex('row', 'flex-start')}
  ${ZeeFontMedium(12, 22)};
  ${MQ.MediaMd} {
    ${!isContactUs ? 'max-width: 239px;' : ''}
  }
  ${MQ.MediaLg} {
    height: ${isContactUs ? '36' : '48'}px;
    ${!isContactUs ? 'max-width: 257px;' : ''}
  }
`;

// export const FieldContainer = styled.div`
//   ${fieldContainer}
// `;

export const MenuTitle = styled.div<{ isContactUs: boolean }>`
  ${({ isContactUs }) =>
    isContactUs ? ZeeFontRegular(13, 15) : ZeeFontBold(14, 18)};
  color: ${({ isContactUs }) =>
    isContactUs ? colors.PrimaryWhiteColorAlpha80 : colors.PrimaryWhiteColor};
  padding: ${({ isContactUs }) => (isContactUs ? '8px 8px 8px 0' : '8px')};
  width: 100%;
  cursor: pointer;
  ${flex('row', 'space-between', 'center')};
  ${MQ.MediaSm} {
    ${({ isContactUs }) => (isContactUs ? ZeeFontRegular(15, 17) : '')};
  }
  ${MQ.MediaLg} {
    padding: ${({ isContactUs }) => (isContactUs ? '14px 2px' : '14px 8px')};
  }
`;
